<template>
  <div class="home">
    <p>Carsome H5</p>
    <div><router-link to="/my_term">Term</router-link></div>
    <div><router-link to="/my_policy">Policy</router-link></div>
    <div><router-link to="/id_term">ID Term</router-link></div>
    <div><router-link to="/id_policy">ID Policy</router-link></div>
    <div><router-link to="/th_term">TH Term</router-link></div>
    <div><router-link to="/th_policy">TH Policy</router-link></div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.home {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
}
</style>
